export default [
  {
    name: "A: Weapon ability: WOUND:6=DAMAGE:2",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "f493c7c1-a201-4fa6-9a77-0fde6ecf0fdb",
        modelTypeName: null,
        unitId: "8188a1b6-ab8b-4ffc-b79f-81dacae0818c",
      },
    ],
    units: [
      {
        id: "8188a1b6-ab8b-4ffc-b79f-81dacae0818c",
        leader: false,
        name: "A: Weapon ability: WOUND:6=DAMAGE:2 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                countPerUnit: 20,
                id: "ee6bea78-fd79-49de-942c-df419a1ae64b",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with WOUND:6=DAMAGE:2",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Wound roll of 6 (unmodified) : set damage to 2",
                    id: "e07acb31-50a6-47a4-b0ff-b58e6a291a3a",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: "2",
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 20,
                id: "88b1d0a9-18d6-4c17-aa2d-5f8c4056fe85",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with WOUND:6=DAMAGE:2",
              },
            ],
            id: "f493c7c1-a201-4fa6-9a77-0fde6ecf0fdb",
            name: "A: Weapon ability: WOUND:6=DAMAGE:2 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "ee6bea78-fd79-49de-942c-df419a1ae64b",
      "88b1d0a9-18d6-4c17-aa2d-5f8c4056fe85",
    ],
  },
  {
    name: "A: Weapon ability: WOUND:6+=DAMAGE:N",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "b6d73a99-f54b-4d2a-a0eb-cbdc50f2d284",
        modelTypeName: null,
        unitId: "4e64de13-7103-4ae8-a4ef-87a169e84ed8",
      },
    ],
    units: [
      {
        id: "4e64de13-7103-4ae8-a4ef-87a169e84ed8",
        leader: false,
        name: "A: Weapon ability: WOUND:6+=DAMAGE:N > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "6f899f76-6829-4332-b443-8ba4d64a125f",
                bs: 2,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with WOUND:6+=DAMAGE:2",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Wound roll of 6+ : set damage to 2",
                    id: "7354dcc2-dad7-4463-85ad-a4ca34fc4643",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Modified",
                            key: "modified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: "2",
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "498778bb-1636-48b0-bfd2-adb84cc62630",
                bs: 2,
                ws: null,
                nameUnique: "Baseline with WOUND:6+=DAMAGE:2",
              },
              {
                name: "Baseline with WOUND:6+=DAMAGE:3",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Wound roll of 6+ : set damage to 3",
                    id: "8b21b7b3-8954-4055-b9c9-c62eeca92a67",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Modified",
                            key: "modified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: "3",
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "74fb2746-f530-43ec-9582-48bd518d2f66",
                bs: 2,
                ws: null,
                nameUnique: "Baseline with WOUND:6+=DAMAGE:3",
              },
            ],
            id: "b6d73a99-f54b-4d2a-a0eb-cbdc50f2d284",
            name: "A: Weapon ability: WOUND:6+=DAMAGE:N > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "6f899f76-6829-4332-b443-8ba4d64a125f",
      "498778bb-1636-48b0-bfd2-adb84cc62630",
      "74fb2746-f530-43ec-9582-48bd518d2f66",
    ],
  },
  {
    name: "A: Weapon ability: WOUND:6=+1MW",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "eea0802d-5484-47d7-b4cf-626ebefeaeeb",
        modelTypeName: null,
        unitId: "1a92566c-2360-4993-be32-bf990048ddd8",
      },
    ],
    units: [
      {
        id: "1a92566c-2360-4993-be32-bf990048ddd8",
        leader: false,
        name: "A: Weapon ability: WOUND:6=+1MW > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "4b198781-1a2b-429e-b932-b90e2d361f46",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with WOUND:6=+1MW",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Wound roll of 6 (unmodified) : 1 mortal wound",
                    id: "d04998cb-ab72-482d-a9f5-85f07c00323d",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        attackSequenceEnds: false,
                        cap: null,
                        mortalWoundsValue: 1,
                        matchWeaponDamage: false,
                      },
                      text: "Mortal wounds",
                      type: "mortalWounds",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "03158638-b75c-4a69-84b1-34da7f8db3f7",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with WOUND:6=+1MW",
              },
            ],
            id: "eea0802d-5484-47d7-b4cf-626ebefeaeeb",
            name: "A: Weapon ability: WOUND:6=+1MW > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "4b198781-1a2b-429e-b932-b90e2d361f46",
      "03158638-b75c-4a69-84b1-34da7f8db3f7",
    ],
  },
  {
    name: "A: Weapon ability: WOUND:6=+2MW",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "1aef5385-ede1-4e1a-a6a2-8265bb64a4dd",
        modelTypeName: null,
        unitId: "db069567-3550-44e6-9962-b3e939ef83c1",
      },
    ],
    units: [
      {
        id: "db069567-3550-44e6-9962-b3e939ef83c1",
        leader: false,
        name: "A: Weapon ability: WOUND:6=+2MW > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "b7203339-2c0c-4998-b725-731a7ddfcb7a",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with WOUND:6=+2MW",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Wound roll of 6 (unmodified) : 2 mortal wounds",
                    id: "e6f0851e-32d3-4f37-ad9c-143dd634b6a6",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        attackSequenceEnds: false,
                        cap: null,
                        mortalWoundsValue: "2",
                        matchWeaponDamage: false,
                      },
                      text: "Mortal wounds",
                      type: "mortalWounds",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "052ddcbf-e0dc-4cab-8741-2443c4845082",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with WOUND:6=+2MW",
              },
            ],
            id: "1aef5385-ede1-4e1a-a6a2-8265bb64a4dd",
            name: "A: Weapon ability: WOUND:6=+2MW > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "b7203339-2c0c-4998-b725-731a7ddfcb7a",
      "052ddcbf-e0dc-4cab-8741-2443c4845082",
    ],
  },
  {
    name: "A: Weapon ability: DENY INVULN",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "3ffeb207-c4c3-47d0-a095-629316f78672",
        modelTypeName: null,
        unitId: "4ba85bdf-63d8-40f1-a86b-fbc5d49fb485",
      },
    ],
    units: [
      {
        id: "4ba85bdf-63d8-40f1-a86b-fbc5d49fb485",
        leader: false,
        name: "A: Weapon ability: DENY INVULN > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "ad7ce922-ae10-49f0-9aa8-15754d3e8fbb",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with DENY INVULN",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Disable invuln",
                    id: "bdfcd532-92ab-4cfb-8d1f-6360e0d1d0e3",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        option: {
                          title: "Disable invuln",
                          key: "disableInvuln",
                        },
                      },
                      text: "Disable ability",
                      type: "disableAbility",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "a3da1bd9-8fe4-4c5a-883c-f26a1f018685",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with DENY INVULN",
              },
            ],
            id: "3ffeb207-c4c3-47d0-a095-629316f78672",
            name: "A: Weapon ability: DENY INVULN > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "ad7ce922-ae10-49f0-9aa8-15754d3e8fbb",
      "a3da1bd9-8fe4-4c5a-883c-f26a1f018685",
    ],
  },
  {
    name: "A: Weapon ability: HIT:6=AUTO WOUND #1",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 10,
    computed_roles: ["Attacker: Ranged", "Defender"],
    computed_toughness: 3,
    computed_wounds: 1,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "8044fdd7-ac88-4a07-ad70-20d26b0895e8",
        modelTypeName: null,
        unitId: "6c6d35e0-a395-4a0a-a168-8395d5bd67d6",
      },
    ],
    units: [
      {
        id: "6c6d35e0-a395-4a0a-a168-8395d5bd67d6",
        leader: false,
        name: "A: Weapon ability: HIT:6=AUTO WOUND > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            invuln: 6,
            modelCount: 10,
            save: 4,
            toughness: 3,
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "feaf8383-eeb5-4ea0-bc62-bdcf361e9c35",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with HIT:6=AUTO WOUND",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Always wound on a hit roll of 6 (unmodified)",
                    id: "96f8a8f0-7444-45d0-849f-b4dd9560d670",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Hit roll",
                            key: "hitRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "9b640f94-f21c-4254-bcb6-fb388f9f6328",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with HIT:6=AUTO WOUND",
              },
            ],
            wounds: 1,
            id: "8044fdd7-ac88-4a07-ad70-20d26b0895e8",
            name: "A: Weapon ability: HIT:6=AUTO WOUND > Unit 1 > Model type 1",
            ignore: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "feaf8383-eeb5-4ea0-bc62-bdcf361e9c35",
      "9b640f94-f21c-4254-bcb6-fb388f9f6328",
    ],
  },
  {
    name: "A: Weapon ability: HIT:6=AUTO WOUND:!VEHICLE",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 10,
    computed_roles: ["Attacker: Ranged", "Defender"],
    computed_toughness: 3,
    computed_wounds: 1,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "49587880-eca3-42ef-8cae-85698ac6fc6b",
        modelTypeName: null,
        unitId: "f531899b-81b9-4037-838a-4bfb14060587",
      },
    ],
    units: [
      {
        id: "f531899b-81b9-4037-838a-4bfb14060587",
        leader: false,
        name: "A: Weapon ability: HIT:6=AUTO WOUND:!VEHICLE > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            invuln: 6,
            modelCount: 10,
            save: 4,
            toughness: 3,
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "ea6a3f9b-ec65-4b42-83f8-616eddee7acc",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with HIT:6=AUTO WOUND:!VEHICLE",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Always wound on a hit roll of 6 (unmodified) (excludes VEHICLE)",
                    id: "50ca3c56-5f19-4744-8a70-515ae8dc4be7",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Hit roll",
                            key: "hitRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                      {
                        data: {
                          keywords: ["VEHICLE"],
                        },
                        preselected: false,
                        text: "Keywords (excludes)",
                        type: "keywordsExcludes",
                      },
                    ],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "68d0b1fb-6bf6-4217-893f-fccde664b558",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with HIT:6=AUTO WOUND:!VEHICLE",
              },
            ],
            wounds: 1,
            id: "49587880-eca3-42ef-8cae-85698ac6fc6b",
            name: "A: Weapon ability: HIT:6=AUTO WOUND:!VEHICLE > Unit 1 > Model type 1",
            ignore: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "ea6a3f9b-ec65-4b42-83f8-616eddee7acc",
      "68d0b1fb-6bf6-4217-893f-fccde664b558",
    ],
  },
  {
    name: "A: Weapon ability D3 MWs on 6s to wound",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "0809514e-ef92-423e-be66-a659ca13ade8",
        modelTypeName: null,
        unitId: "7d7d42fd-d3b8-4c84-b0f2-7c377b22fc34",
      },
    ],
    units: [
      {
        id: "7d7d42fd-d3b8-4c84-b0f2-7c377b22fc34",
        leader: false,
        name: "A: Weapon ability D3 MWs on 6s to wound > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Weapon with ability",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 20,
                strength: 5,
                ap: -3,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Wound roll of 6 (unmodified) : D3 mortal wounds",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        attackSequenceEnds: false,
                        cap: null,
                        mortalWoundsValue: "D3",
                        matchWeaponDamage: false,
                      },
                      text: "Mortal wounds",
                      type: "mortalWounds",
                    },
                    scope: ["weapon"],
                    id: "2d946822-e5a4-410f-9227-8491e4ec730f",
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "dc0d5b35-434d-41b8-ae0a-213256dd195d",
                bs: 2,
                ws: null,
                nameUnique: "Weapon with ability",
              },
            ],
            id: "0809514e-ef92-423e-be66-a659ca13ade8",
            name: "A: Weapon ability D3 MWs on 6s to wound > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["dc0d5b35-434d-41b8-ae0a-213256dd195d"],
  },
  {
    name: "A: Weapon ability: Single-use hit re-rolls",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "43ac1703-c825-4622-82b7-b984b14a57aa",
        modelTypeName: null,
        unitId: "1742f428-d096-4881-9045-5af8e24f59cc",
      },
    ],
    units: [
      {
        id: "1742f428-d096-4881-9045-5af8e24f59cc",
        leader: false,
        name: "A: Weapon ability: Single-use hit re-rolls > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                countPerUnit: 10,
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "7171e8bc-c6a2-42f2-b5af-7cdfaa530dac",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "With Hit roll : re-roll one failed",
                countPerUnit: 10,
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Re-roll one possible failed hit roll",
                    id: "3f0df4a4-e217-4490-9871-793ca256f569",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "c42de207-f21a-43c6-9439-924afddc32c4",
                bs: 3,
                ws: null,
                nameUnique: "With Hit roll : re-roll one failed",
              },
              {
                name: "With x2 Hit roll : re-roll one failed",
                countPerUnit: 10,
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Re-roll one possible failed hit roll",
                    id: "ba7e8f3d-44a0-48db-91c1-5e2c806a2c03",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                  {
                    description: "Re-roll one possible failed hit roll",
                    scope: ["weapon"],
                    id: "10bc1485-2855-42db-ba38-c1fae139d9ca",
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "aba110cf-051f-4e1a-b459-525d69b896ba",
                bs: 3,
                ws: null,
                nameUnique: "With x2 Hit roll : re-roll one failed",
              },
              {
                name: "With x3 Hit roll : re-roll one failed",
                countPerUnit: 10,
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Re-roll one possible failed hit roll",
                    id: "94224f17-ce3b-4062-b8c2-21548b25fbe1",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                  {
                    description: "Re-roll one possible failed hit roll",
                    scope: ["weapon"],
                    id: "5da54a04-9b86-4805-a283-8cb34ccd329d",
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                  {
                    description: "Re-roll one possible failed hit roll",
                    scope: ["weapon"],
                    id: "3ebe5bcc-60de-4ccf-99eb-7df33544b959",
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "d14f2133-b096-4941-bea6-7e479d9fb595",
                bs: 3,
                ws: null,
                nameUnique: "With x3 Hit roll : re-roll one failed",
              },
            ],
            id: "43ac1703-c825-4622-82b7-b984b14a57aa",
            name: "A: Weapon ability: Single-use hit re-rolls > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "A: Weapon ability: Single-use wound re-rolls",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "686340a7-b8bd-4c69-8d22-f5d90431932c",
        modelTypeName: null,
        unitId: "82d39673-a647-4007-9420-93e318ab0b7a",
      },
    ],
    units: [
      {
        id: "82d39673-a647-4007-9420-93e318ab0b7a",
        leader: false,
        name: "A: Weapon ability: Single-use wound re-rolls > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                countPerUnit: 10,
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "6c7e53b1-7d7b-4bff-80b7-041eed5ea6e3",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "With Wound roll : re-roll one failed",
                countPerUnit: 10,
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Re-roll one possible failed wound roll",
                    id: "195a8757-89d9-414a-8970-c409860bb03d",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Wound roll",
                          key: "woundRoll",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "c03b60a3-fc3c-4f6b-a670-9e9f5bae4fa5",
                bs: 3,
                ws: null,
                nameUnique: "With Wound roll : re-roll one failed",
              },
            ],
            id: "686340a7-b8bd-4c69-8d22-f5d90431932c",
            name: "A: Weapon ability: Single-use wound re-rolls > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "A: Weapon ability: Single-use damage re-rolls",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "2bb66002-e191-4c9f-8eb1-4a44958a8383",
        modelTypeName: null,
        unitId: "8c58625b-8ef6-43f5-9fbb-ba695c1ccb6b",
      },
    ],
    units: [
      {
        id: "8c58625b-8ef6-43f5-9fbb-ba695c1ccb6b",
        leader: false,
        name: "A: Weapon ability: Single-use damage re-rolls > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                countPerUnit: 3,
                type: "Ranged",
                attacks: 2,
                strength: 9,
                ap: -3,
                damage: "D3+3",
                id: "1bfd44a0-bd81-4c48-a558-ce6343c35f05",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Damage roll : re-roll one result of 1",
                countPerUnit: 3,
                type: "Ranged",
                attacks: 2,
                strength: 9,
                ap: -3,
                damage: "D3+3",
                abilities: [
                  {
                    description: "Re-roll one damage result of 1",
                    id: "24d0b593-7b8e-4285-93de-0fda5e8a21b5",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "Single",
                          key: "single",
                        },
                        valueRange: [],
                        valueSingle: "1",
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "422d4562-4344-40ff-91e8-88dc68fb38d1",
                bs: 3,
                ws: null,
                nameUnique: "Damage roll : re-roll one result of 1",
              },
              {
                name: "Damage roll : re-roll one result of 1-3",
                countPerUnit: 3,
                type: "Ranged",
                attacks: 2,
                strength: 9,
                ap: -3,
                damage: "D3+3",
                abilities: [
                  {
                    description: "Re-roll one damage result of 1–3",
                    id: "246d09bf-f099-42a2-9e65-7d464398995e",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "Range",
                          key: "range",
                        },
                        valueRange: [1, 3],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "093447cb-8352-45a2-8c07-da2860cf21cc",
                bs: 3,
                ws: null,
                nameUnique: "Damage roll : re-roll one result of 1-3",
              },
              {
                name: "Damage roll : re-roll one result of 1-4",
                countPerUnit: 3,
                type: "Ranged",
                attacks: 2,
                strength: 9,
                ap: -3,
                damage: "D3+3",
                abilities: [
                  {
                    description: "Re-roll one damage result of 1–4",
                    id: "58ef41a4-8192-43cf-9ae0-26dbd68c28de",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        limit: {
                          title: "Single",
                          key: "single",
                        },
                        resultToReRoll: {
                          title: "Range",
                          key: "range",
                        },
                        valueRange: [1, 4],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "bb98df3b-f9e0-4b73-a3ac-97f67f3a30d6",
                bs: 3,
                ws: null,
                nameUnique: "Damage roll : re-roll one result of 1-4",
              },
            ],
            id: "2bb66002-e191-4c9f-8eb1-4a44958a8383",
            name: "A: Weapon ability: Single-use damage re-rolls > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
]
